import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import * as modalTypes from 'types/modal';
import DeleteAccount from './DeleteAccount/container';
import UpdateFeedItem from './UpdateFeedItem/container';
import DeleteFeedItem from './DeleteFeedItem/container';
import DeleteFeed from './DeleteFeed/container';
import LeaveFeed from './LeaveFeed/container';
import DeleteRelation from './DeleteRelation/container';
import DeleteMember from './DeleteMember/container';
import KickRoomUser from './KickRoomUser/container';

class ModalManager extends PureComponent {
    render() {
        const { type, _currentUser } = this.props;
        let Modal = null;

        switch (type) {
            case modalTypes.MODAL_DELETE_ACCOUNT:
                Modal = DeleteAccount;
                break;
            case modalTypes.MODAL_UPDATE_FEEDITEM:
                Modal = UpdateFeedItem;
                break;
            case modalTypes.MODAL_DELETE_FEEDITEM:
                Modal = DeleteFeedItem;
                break;
            case modalTypes.MODAL_DELETE_GROUP:
                Modal = DeleteFeed;
                break;
            case modalTypes.MODAL_LEAVE_GROUP:
                Modal = LeaveFeed;
                break;
            case modalTypes.MODAL_DELETE_RELATION:
                Modal = DeleteRelation;
                break;
            case modalTypes.MODAL_DELETE_MEMBER:
                Modal = DeleteMember;
                break;
            case modalTypes.MODAL_KICK_ROOM_USER:
                Modal = KickRoomUser;
                break;
            default:
                return null;
        }

        if (Modal) return <Modal _currentUser={_currentUser} />;
        return null;
    }
}

ModalManager.propTypes = {
    type: PropTypes.string,
    _currentUser: PropTypes.string
};

export default ModalManager;
